<template>
  <div class="container">
    <div class="row mb-4">
      <div class="col-md-8">
        <span class="text-black">
          <i class="fas fa-equals mr-2"></i>Saldo em Dinheiro:
        </span>
      </div>
      <div class="col-md-4 text-right">
        <div class="mr-2">
          {{ closingBalance | decimal }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <number-input
          :alias="'O valor que deseja transferir'"
          v-model="form.value.value"
        />
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-md-12">
        <span>Transferir Para:</span>
        <account-select-input
          :exceptId="this.accountOriginId"
          @input="setAccountDestination($event)"
        />
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-md-8">
        <span class="text-black">
          <i class="fas fa-equals mr-2"></i>Saldo restante (Dinheiro):
        </span>
      </div>
      <div class="col-md-4 text-right">
        <div class="mr-2">
          {{ closingBalance - form.value.value | decimal }}
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-md-12">
        <span class="text-info">
          Este saldo restante ficará para a próxima abertura de caixa.
        </span>        
      </div>
    </div>

    <!-- <template v-if="form.account_destination.value !== null"> -->
    <template >
      <div>
        <button
          role="button"
          class="btn btn-sm btn-success btn-block"
          @click="storeTransfer"
          :disabled="loading"
        >
          <i :class="['fas fa-sync mr-2', { 'fa-spin': loading }]"></i>
          <span v-if="loading == false">Transferir</span>
          <span v-if="loading == true">Transferindo aguarde...</span>
        </button>
      </div>
    </template>
    <div class="row">
      <div class="col-md-12">
        <error-handler class="mt-4" :error="error" />
      </div>
    </div>
  </div>
</template>

<script>
import AccountSelectInput from "../inputs/AccountSelectInput";
import Form from "../../../mixins/Form";

export default {
  components: { AccountSelectInput },

  props: {
    accountOriginId: {},
  },

  data: () => {
    return {
      form: new Form({
        description: {
          default: "TRANSFERÊNCIA",
        },

        history: {},

        value: {},

        account_destination: {},

        account_id: {},
      }),

      error : null,

      loading: false,
    };
  },

  created() {
    this.form.account_id.value = this.accountOriginId;
  },

  computed: {
    closingBalance() {
      return this.$store.getters["drawer/closingBalance"];
    },
  },

  methods: {
    setAccountDestination(events) {
      this.form.account_destination.value = events.id;
    },

    async storeTransfer() {
      this.error = null
      
      this.$store.commit('showLoading')
      
      await this.$store.dispatch('accountTransfer/postAccountTransfer', this.form.getValues())
        .then((response) => {
          this.$emit("store");
        })
        .catch((error) => {
          this.error = error
        })

      this.$store.commit('hideLoading')
      
    },
  },
};
</script>

<style>
</style>